
"use client";

import {
  Navbar as HeroUINavbar,
  NavbarContent,
  NavbarMenu,
  NavbarMenuToggle,
  NavbarBrand,
  NavbarItem,
  NavbarMenuItem,
} from "@heroui/navbar";
import { Kbd } from "@heroui/kbd";
import { Link } from "@heroui/link";
import { Input } from "@heroui/input";
import  UserBar  from "@/app/acount/AcountBar";
import { siteConfig } from "@/config/site";
import { useEffect, useState } from "react";
import { Logo } from "./icons";

export const Navbar = () => {
  const searchInput = (
    <Input
      aria-label="Search"
      classNames={{
        inputWrapper: "bg-default-100",
        input: "text-sm",
      }}
      endContent={
        <Kbd className="hidden lg:inline-block" keys={["command"]}>
          K
        </Kbd>
      }
      labelPlacement="outside"
      placeholder="Search..."

      type="search"
    />
  );


  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {

  }, [isOpen]);

  return (
    <HeroUINavbar maxWidth="xl" position="sticky" isMenuOpen={isOpen} onMenuOpenChange={setIsOpen} >
      <NavbarContent className="basis-1/9 sm:basis-full gap-0 width-[20px]" justify="start">
        <NavbarMenuToggle className="sm:hidden" />
        <NavbarBrand as="li">
          <Link href="/" color="foreground">
            <Logo/>
            <p className="hiden font-bold text-inherit">Luckyho <br/> GYM</p>
          </Link>
        </NavbarBrand>
      </NavbarContent >
      
      <NavbarContent className="hidden sm:flex gap-4" justify="end">
          {siteConfig.navItems.map((item) => (
              <NavbarItem key={item.href}>
                <Link
                  color="foreground"
                  href={item.href}
                >
                  {//item.icon
                  }
                  <b>{item.label}</b>
                </Link>
              </NavbarItem>
          ))}
      </NavbarContent>

      <NavbarMenu>
          <div className="mx-4 mt-2 flex flex-col gap-2 min-h-lg">
            {siteConfig.navItems.map((item, index) => (
              <NavbarMenuItem key={`${item}-${index}`} >
                <Link
                  color={
                    index === 2
                      ? "primary"
                      : index === siteConfig.navItems.length - 1
                        ? "danger"
                        : "foreground"
                  }
                  href={item.href}
                  size="lg"
                  onClick={() => { setIsOpen(false)}}
                >
                  {item.label}
                </Link>
              </NavbarMenuItem>
            ))}
          </div>
        </NavbarMenu>
        <UserBar/>
      </HeroUINavbar>
  );
};
